module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/video-c-3-d8e871d63f0663565e3cee1bd2c927b2.jpg";